import React from 'react';
import { useNavigation } from '../../lib/navigation';
import { saveLanguageToCache, getLanguageFromCache } from '../../lib/i18n';
import { useTranslations } from '../../lib/useTranslations';

interface LanguageSwitcherProps {
  className?: string;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className }) => {
  const navigation = useNavigation();
  const translations = useTranslations();
  const [currentLang, setCurrentLang] = React.useState<string>('en');

  React.useEffect(() => {
    const lang = (navigation.query.lang as string) || getLanguageFromCache() || 'en';
    setCurrentLang(lang);
  }, [navigation.query.lang]);

  const handleLanguageChange = (newLang: string) => {
    saveLanguageToCache(newLang);
    setCurrentLang(newLang);

    const currentPath = navigation.pathname || (typeof window !== 'undefined' ? window.location.pathname : '/');
    navigation.push(`${currentPath}?lang=${newLang}`);
  };

  const languages = [
    { code: 'en', label: 'English', flag: '🇺🇸' },
    { code: 'ru', label: 'Русский', flag: '🇷🇺' },
    { code: 'kk', label: 'Қазақша', flag: '🇰🇿' },
  ];

  return (
    <div className={`language-switcher ${className || ''}`}>
      <select
        value={currentLang}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="language-select"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.label}
          </option>
        ))}
      </select>
      
      <style>{`
        .language-switcher {
          position: relative;
          display: inline-block;
        }
        
        .language-select {
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          color: var(--brand-color, #2090FF);
          padding: 8px 12px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          outline: none;
          transition: all 0.2s ease;
        }
        
        .language-select:hover {
          background: rgba(255, 255, 255, 0.15);
          border-color: rgba(255, 255, 255, 0.3);
        }
        
        .language-select:focus {
          background: rgba(255, 255, 255, 0.2);
          border-color: var(--brand-color, #2090FF);
          box-shadow: 0 0 0 2px var(--brand-color, #2090FF)33;
        }
        
        .language-select option {
          background: var(--background-color, #313131);
          color: white;
          padding: 8px;
        }
      `}</style>
    </div>
  );
};